module.exports = __webpack_public_path__ + "static/media/avatar_profil.0e2e20ef.png";